import de from '../config/languages/de';
import es from '../config/languages/es';
import en from '../config/languages/en';
import fr from '../config/languages/fr';
import it from '../config/languages/it';

const languageMaps = {
  de: de,
  en: en,
  es: es,
  it: it,
  fr: fr
};

const getText = dict => id => {
  return dict[id] ?? id;
};

export const getDict = language => {
  const dict = languageMaps[language];
  return getText(dict || {});
};
